import React from "react";

export default function NotificationIcon() {
    return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M12 21C13.1 21 14 20.1692 14 19.1538H10C10 20.1692 10.89 21 12 21ZM18 15.4615V10.8462C18 8.01231 16.36 5.64 13.5 5.01231V4.38462C13.5 3.61846 12.83 3 12 3C11.17 3 10.5 3.61846 10.5 4.38462V5.01231C7.63 5.64 6 8.00308 6 10.8462V15.4615L4 17.3077V18.2308H20V17.3077L18 15.4615Z" fill="none"/>
    </svg>;
}
